import type { Ticket as TicketModel } from '@/adapters/catalogv1.g';

export function extractTicket(model: TicketModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.ticket_ref ?? '',
    title: model.title ?? '',
    description: model.description,
    ticketType: model.ticket_type,
    status: model.status,
    statusReason: model.status_reason,
    priority: model.priority,
    impact: model.impact,
    urgency: model.urgency,
    category: model.category,
    subcategory: model.subcategory,
    source: model.source,
    tags: model.tags,
    requesterRef: model.requester_ref,
    requesterName: model.requester_name,
    requesterEmail: model.requester_email,
    assigneeRef: model.assignee_ref,
    assigneeName: model.assignee_name,
    assignmentGroupRef: model.assignment_group_ref,
    assignmentGroupName: model.assignment_group_name,
    externalId: model.external_id,
    resolutionCode: model.resolution_code,
    resolutionNotes: model.resolution_notes,
    closeCode: model.close_code,
    closeNotes: model.close_notes,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    dueAt: model.due_at ? new Date(model.due_at) : undefined,
    resolvedAt: model.resolved_at ? new Date(model.resolved_at) : undefined,
    closedAt: model.closed_at ? new Date(model.closed_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogTicket = ReturnType<typeof extractTicket>;
